import axios from 'axios';

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const isProduction =
  import.meta.env.PROD &&
  (import.meta.env.VITE_ENVIRONMENT === 'prod' ||
    import.meta.env.VITE_ENVIRONMENT === 'production');

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.data) {
      const data = error.response.data;
      const err = data.error;
      const extractedMessage = data.message ?? (typeof err === 'string' ? err : err?.message);

      if (extractedMessage) {
        error.message = extractedMessage;
      } else {
        // Fallback to status-based messages
        const statusMessages: Record<number, string> = {
          400: 'Invalid request. Please check your input and try again.',
          401: 'Unauthorized. Please sign in again.',
          403: 'Access denied.',
          404: 'Resource not found.',
          409: 'This request conflicts with existing data.',
          500: 'Server error. Please try again later.',
        };
        error.message =
          statusMessages[error.response.status] ||
          `Request failed with status ${error.response.status}`;
      }
    } else if (error.request) {
      error.message = 'Network error. Please check your connection and try again.';
    } else {
      error.message = error.message || 'An unexpected error occurred.';
    }

    return Promise.reject(error);
  },
);

export default apiClient;
